import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";
import MessageEnum, {
  getName
} from "../../../framework/src/Messages/MessageEnum";

// Customizable Area Start
import { imgPasswordInVisible, imgPasswordVisible } from "./assets";
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
}

export interface S {
  // Customizable Area Start
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  otpAuthToken: string;
  reTypePassword: string;
  data: any[];
  passwordHelperText: string;
  enablePasswordField: boolean;
  enableReTypePasswordField: boolean;
  countryCodeSelected: string;
  phone: string;

  emailAddress: string;
  phoneNumber: string;
  emailError: string;
  phoneError: string;
  privacyPolicyAccepted: boolean;
  privacyPolicyError: string;
  fullPhoneNumber: string;
  callingCode: string;
  response: string;
  privacyPolicyContent: string;
  termsConditionsContent: string;
  privacyPolicyMessage: boolean;
  flagResponse: FlagResponse;
  // Customizable Area End
}

interface CountryAttributes {
  name: string;
  emoji_flag: string;
  country_code: string;
}

interface CountryFlagResponse {
  id: string;
  type: string;
  attributes: CountryAttributes;
}

interface FlagResponse {
  response: CountryFlagResponse[];
}

export interface SS {
  // Customizable Area Start
  id: any;
  navigation: string;
  // Customizable Area End
}

export default class EmailAccountRegistrationController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  arrayholder: any[];
  passwordReg: RegExp;
  emailReg: RegExp;
  createAccountApiCallId: any;
  validationApiCallId: string = "";

  imgPasswordVisible: any;
  imgPasswordInVisible: any;

  labelHeader: any;
  labelFirstName: string;
  lastName: string;
  labelEmail: string;
  labelPassword: string;
  labelRePassword: string;
  labelLegalText: string;
  labelLegalTermCondition: string;
  labelLegalPrivacyPolicy: string;
  btnTextSignUp: string;

  currentCountryCode: any;

  handleSignUpApiCallId: string = "";
  handlePrivacyPolicyApiCallId: string = "";
  handleTermsConditionsApiCallId: string = "";
  getCountryFlagsApiCallId: string = "";
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.NavigationPayLoadMessage),
      getName(MessageEnum.CountryCodeMessage),
      getName(MessageEnum.RestAPIRequestMessage),
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      getName(MessageEnum.RestAPIRequestMethodMessage),
      getName(MessageEnum.RestAPIResponceErrorMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
      getName(MessageEnum.RestAPIResponceSuccessMessage),

    ];
    this.receive = this.receive.bind(this);
    this.isStringNullOrBlank = this.isStringNullOrBlank.bind(this);

    runEngine.attachBuildingBlock(this, this.subScribedMessages);

    this.state = {
      // Customizable Area Start
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      reTypePassword: "",
      otpAuthToken: "",
      data: [],
      passwordHelperText: "",
      enablePasswordField: true,
      enableReTypePasswordField: true,
      phone: "",

      emailAddress: "",
      phoneNumber: "",
      countryCodeSelected: "DE",
      emailError: "",
      phoneError: "",
      privacyPolicyAccepted: true,
      privacyPolicyError: "",
      fullPhoneNumber: "",
      callingCode: '49',
      response: "",
      privacyPolicyContent: "",
      termsConditionsContent: "",
      privacyPolicyMessage: false,
      flagResponse: {
        response: [],
      },
      // Customizable Area End
    };

    // Customizable Area Start
    this.arrayholder = [];
    this.passwordReg = new RegExp("\\w+");
    this.emailReg = new RegExp("\\w+");

    this.imgPasswordVisible = imgPasswordVisible;
    this.imgPasswordInVisible = imgPasswordInVisible;

    this.labelHeader = configJSON.labelHeader;
    this.labelFirstName = configJSON.labelFirstName;
    this.lastName = configJSON.lastName;
    this.labelEmail = configJSON.labelEmail;
    this.labelPassword = configJSON.labelPassword;
    this.labelRePassword = configJSON.labelRePassword;
    this.labelLegalText = configJSON.labelLegalText;
    this.labelLegalTermCondition = configJSON.labelLegalTermCondition;
    this.labelLegalPrivacyPolicy = configJSON.labelLegalPrivacyPolicy;
    this.btnTextSignUp = configJSON.btnTextSignUp;
    // Customizable Area End
  }

  async componentDidMount(): Promise<void> {
    window.addEventListener('beforeunload', this.handleUnload);

    const emailAddress = localStorage.getItem('emailAddress');
    if (emailAddress !== null) {
      this.setState({ emailAddress });
    }

    const phoneNumber = localStorage.getItem('phoneNumber');
    if (phoneNumber !== null) {
      this.setState({ phoneNumber });
    }

    const countryCodeSelected = localStorage.getItem('countryCodeSelected');
    if (countryCodeSelected !== null) {
      this.setState({ countryCodeSelected });
    }

    const callingCode = localStorage.getItem('callingCode');
    if (callingCode !== null) {
      this.setState({ callingCode });
    }

    this.getCountryFlags();
    localStorage.clear();
  }


  async componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleUnload);
  }

  handleUnload() {
    localStorage.clear();
  }

  showNavigationData = (message: Message) => {
    if (getName(MessageEnum.NavigationPayLoadMessage) === message.id) {
      let data = message.getData(getName(MessageEnum.NavigationPayLoadMessage))

      this.setState({ emailAddress: data.emailAddress });
      this.setState({ phoneNumber: data.phoneNumber });
      this.setState({ countryCodeSelected: data.countryCodeSelected });
      this.setState({ callingCode: data.callingCode });
    }
  };

  async receive(from: string, message: Message) {
    // Customizable Area Start
    this.showNavigationData(message)
    const msgId = message.id;
    if (getName(MessageEnum.RestAPIResponceMessage) === msgId) {
      this.handleRestAPIResponse(message);
    } else if (getName(MessageEnum.NavigationPayLoadMessage) === msgId) {
      this.handleNavigationPayload(message);
    } else if (getName(MessageEnum.CountryCodeMessage) === msgId) {
      this.handleCountryCode(message);
    }
    // Customizable Area End
  }

  private handleRestAPIResponse(message: Message) {
    const apiCallId = message.getData(getName(MessageEnum.RestAPIResponceDataMessage));
    const responseJson = message.getData(getName(MessageEnum.RestAPIResponceSuccessMessage));
    const errorResponse = message.getData(getName(MessageEnum.RestAPIResponceErrorMessage));
    if (!apiCallId || !responseJson) return;

    if (apiCallId === this.validationApiCallId) {
      this.handleValidationResponse(responseJson);
    } else if (apiCallId === this.createAccountApiCallId) {
      this.handleCreateAccountResponse(responseJson, errorResponse);
    } else if (apiCallId === this.handleSignUpApiCallId) {
      this.handleSignUpResponse(responseJson);
    } else if (apiCallId === this.handlePrivacyPolicyApiCallId) {
      this.handlePrivacyPolicyResponse(responseJson);
    } else if (apiCallId === this.handleTermsConditionsApiCallId) {
      this.handleTermsConditionsResponse(responseJson);
    } else if (apiCallId === this.getCountryFlagsApiCallId) {
      this.getCountryFlagsResponse(responseJson);
    }
  }

  private getCountryFlagsResponse(responseJson: any) {
    this.setState({
      flagResponse: {
        response: responseJson.data
      }
    });
  }

  private handleValidationResponse(responseJson: any) {
    this.arrayholder = responseJson.data;
    if (this.arrayholder?.length) {
      const regexData = this.arrayholder[0];
      if (regexData.password_validation_regexp) {
        this.passwordReg = new RegExp(regexData.password_validation_regexp);
      }
      if (regexData.password_validation_rules) {
        this.setState({ passwordHelperText: regexData.password_validation_rules });
      }
      if (regexData.email_validation_regexp) {
        this.emailReg = new RegExp(regexData.email_validation_regexp);
      }
    }
  }

  private handleCreateAccountResponse(responseJson: any, errorResponse: any) {
    if (!responseJson.errors) {
      const msg = new Message(getName(MessageEnum.AccoutResgistrationSuccess));
      msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
      this.send(msg);
    } else {
      this.parseApiErrorResponse(responseJson);
    }
    this.parseApiCatchErrorResponse(errorResponse);
  }

  private handlePrivacyPolicyResponse(responseJson: any) {
    if (responseJson?.data) {
      this.setState({ privacyPolicyContent: responseJson.data[0].description });



      const payloadData = { privacyPolicyContent: this.state.privacyPolicyContent, showProfile: true, emailAddress: this.state.emailAddress, phoneNumber: this.state.phoneNumber, countryCodeSelected: this.state.countryCodeSelected, callingCode: this.state.callingCode }
      const msgNavigation = new Message(getName(MessageEnum.NavigationMessage));
      msgNavigation.addData(getName(MessageEnum.NavigationTargetMessage), "TermsConditionsDetail");
      msgNavigation.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
      const raiseMessage: Message = new Message(getName(MessageEnum.NavigationPayLoadMessage));
      raiseMessage.addData(getName(MessageEnum.NavigationPayLoadMessage), payloadData);
      msgNavigation.addData(getName(MessageEnum.NavigationRaiseMessage), raiseMessage);
      this.send(msgNavigation);

    }
  }

  private handleTermsConditionsResponse(responseJson: any) {
    if (responseJson?.data) {
      this.setState({ termsConditionsContent: responseJson.data[0].description });

      const payloadData = { termsConditionsContent: this.state.termsConditionsContent, showProfile: true, emailAddress: this.state.emailAddress, phoneNumber: this.state.phoneNumber, countryCodeSelected: this.state.countryCodeSelected, callingCode: this.state.callingCode }
      const msgNavigation = new Message(getName(MessageEnum.NavigationMessage));
      msgNavigation.addData(getName(MessageEnum.NavigationTargetMessage), "TermsConditionsUsers");
      msgNavigation.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
      const raiseMessage: Message = new Message(getName(MessageEnum.NavigationPayLoadMessage));
      raiseMessage.addData(getName(MessageEnum.NavigationPayLoadMessage), payloadData);
      msgNavigation.addData(getName(MessageEnum.NavigationRaiseMessage), raiseMessage);
      this.send(msgNavigation);

    }
  }

  private handleSignUpResponse(responseJson: any) {
    if (responseJson?.meta) {
      this.setState({ emailError: "", phoneError: "" });

      const payloadData = { fullPhoneNumber: this.state.fullPhoneNumber, showProfile: true, isRegistration: true, emailAddress: this.state.emailAddress, phoneNumber: this.state.phoneNumber, countryCodeSelected: this.state.countryCodeSelected, callingCode: this.state.callingCode }
      const msgNavigation = new Message(getName(MessageEnum.NavigationMessage));
      msgNavigation.addData(getName(MessageEnum.NavigationTargetMessage), "OTPInputAuth");
      msgNavigation.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
      const raiseMessage: Message = new Message(getName(MessageEnum.NavigationPayLoadMessage));
      raiseMessage.addData(getName(MessageEnum.NavigationPayLoadMessage), payloadData);
      msgNavigation.addData(getName(MessageEnum.NavigationRaiseMessage), raiseMessage);
      this.send(msgNavigation);


      return;
    }

    if (!responseJson?.errors || !Array.isArray(responseJson.errors) || responseJson.errors.length === 0) {
      console.error("Unexpected error format:", responseJson);
      return;
    }
    let emailError = "";
    let phoneError = "";

    responseJson.errors.forEach((error: { type?: string; message: string }) => {
      if (error.type) {
        switch (error.type) {
          case 'email_already_used':
            emailError = error.message;
            break;
          case 'phone_number_already_used':
            phoneError = error.message;
            break;
        }
      } else {
        if (error.message === "Invalid phone number") {
          phoneError = "Invalid phone number format";
        }
      }
    });

    this.setState({ emailError, phoneError });
    console.error("Sign up failed with errors in responseJson:", responseJson);
  }


  private handleNavigationPayload(message: Message) {
    const otpAuthTkn = message.getData(getName(MessageEnum.AuthTokenDataMessage));
    if (otpAuthTkn && otpAuthTkn.length > 0) {
      this.setState({ otpAuthToken: otpAuthTkn });
      runEngine.debugLog("otpAuthTkn", this.state.otpAuthToken);
      runEngine.unSubscribeFromMessages(this as IBlock, [message.id]);
    }
  }

  private handleCountryCode(message: Message) {
    const selectedCode = message.getData(getName(MessageEnum.CountyCodeDataMessage));
    if (selectedCode !== undefined) {
      const countryCode =
        selectedCode.indexOf("+") > 0 ? selectedCode.split("+")[1] : selectedCode;
      this.setState({ countryCodeSelected: countryCode });
    }
  }


  // Customizable Area Start

  handleCountryCodeChange = (event: { target: { value: string; }; }) => {
    const selectedCountryCode = event.target.value;
    const selectedCountry = this.state.flagResponse.response.find(country => country.id === selectedCountryCode);

    if (selectedCountry) {
      this.setState({
        countryCodeSelected: selectedCountryCode,
        callingCode: selectedCountry.attributes.country_code,
        fullPhoneNumber: `${selectedCountry.attributes.country_code}${this.state.phoneNumber}`
      });
    }
  };

  handleVerifyButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    localStorage.setItem('callingCode', this.state.callingCode)
    localStorage.setItem('countryCodeSelected', this.state.countryCodeSelected)
    localStorage.setItem('emailAddress', this.state.emailAddress)
    localStorage.setItem('phoneNumber', this.state.phoneNumber)
    sessionStorage.setItem('fullPhoneNumber', this.state.fullPhoneNumber)

    e.stopPropagation();
    if (!this.state.privacyPolicyAccepted) {
      this.setState({ privacyPolicyError: "You have to agree with Privacy Policy and Terms and Conditions to Sign up" });
    } else {
      this.setState({ privacyPolicyError: "" });
      this.handleSignUp();
    }
  };

  closePrivacyError = () => {
    this.setState({ privacyPolicyError: "" })
  }

  handleSignUp = async () => {
    const headers = {
      "Content-Type": configJSON.signUpApiContentType
    };

    // Construct the request body according to the required format
    const attrs = {
      email: this.state.emailAddress,
      full_phone_number: this.state.fullPhoneNumber,
      privacy_policy_and_terms_and_condition: this.state.privacyPolicyAccepted
    };

    const data = {
      type: "sms_account",
      attributes: attrs
    };

    const httpBody = {
      data: data
    };

    const handleSignUpMsg = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.handleSignUpApiCallId = handleSignUpMsg.messageId;

    handleSignUpMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.urlSignUp
    );

    handleSignUpMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );

    handleSignUpMsg.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );

    handleSignUpMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.signUpApiMethodType
    );

    runEngine.sendMessage(handleSignUpMsg.id, handleSignUpMsg);
  };

  handlePrivacyPolicyCheckBoxChange = (event: { target: { checked: boolean; }; }) => {
    this.setState({ privacyPolicyAccepted: event.target.checked, privacyPolicyError: "" });
  };

  // Handle email address change
  handleEmailAddressChange = (event: { target: { value: string; }; }) => {
    this.setState({ emailAddress: event.target.value }, this.validateEmailAddress);
  };

  // Handle phone number change
  handlePhoneNumberChange = (event: { target: { value: string; }; }) => {
    let rawPhone = event.target.value.replace(/\D/g, "");

    if (rawPhone.length > 10) return;

    this.setState({
      phoneNumber: rawPhone,
      fullPhoneNumber: `${this.state.callingCode}${rawPhone}`
    }, this.validatePhoneNumber);
    sessionStorage.setItem("phone", this.state.phoneNumber);
  };

  // Validate phone number onBlur (when user leaves input field)
  validatePhoneNumber = () => {
    this.setState({
      phoneError: this.state.phoneNumber.length === 10 || this.state.phoneNumber === ""
        ? ""
        : "Invalid phone number format"
    });
  };

  // Format phone number for display: "XXX XXX XXXX"
  formatPhoneNumber = (phone: string | any[]) => {
    if (phone?.length > 6) {
      return `${phone.slice(0, 3)} ${phone.slice(3, 6)} ${phone.slice(6)}`;
    } else if (phone?.length > 3) {
      return `${phone.slice(0, 3)} ${phone.slice(3)}`;
    }
    return phone;
  };

  // Prevent non-numeric input
  preventInvalidInput = (event: { key: string; preventDefault: () => void; }) => {
    const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Tab"];

    if (!/^\d$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  };

  validateEmailAddress = () => {
    // Improved email validation regex that is less susceptible to ReDoS
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    this.setState({
      emailError: emailPattern.test(this.state.emailAddress) || this.state.emailAddress === ""
        ? ""
        : "Invalid email address"
    });
  };

  handlePrivacyPolicyClick = () => {
    this.getPrivacyPolicy();
  }

  handleTermsAndConditionsClick = () => {
    this.getTermsConditions();
  }

  getTermsConditions = async () => {
    const headers = {
      "Content-Type": configJSON.signUpApiContentType
    };

    const handleTermsConditionsMsg = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.handleTermsConditionsApiCallId = handleTermsConditionsMsg.messageId;

    handleTermsConditionsMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.urlGetTermsConditions
    );

    handleTermsConditionsMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );

    handleTermsConditionsMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.termsConditionsApiMethodType
    );

    runEngine.sendMessage(handleTermsConditionsMsg.id, handleTermsConditionsMsg);
  };

  getPrivacyPolicy = async () => {
    const headers = {
      "Content-Type": configJSON.signUpApiContentType
    };

    const handlePrivacyPolicyMsg = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.handlePrivacyPolicyApiCallId = handlePrivacyPolicyMsg.messageId;

    handlePrivacyPolicyMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.urlGetPrivacyPolicy
    );

    handlePrivacyPolicyMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );

    handlePrivacyPolicyMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.privacyPolicyApiMethodType
    );

    runEngine.sendMessage(handlePrivacyPolicyMsg.id, handlePrivacyPolicyMsg);
  };

  goToPrivacyPolicy() {
    const msg: Message = new Message(
      getName(MessageEnum.NavigationPrivacyPolicyMessage)
    );
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
  }

  goToTermsAndCondition() {
    const msg: Message = new Message(
      getName(MessageEnum.NavigationTermAndConditionMessage)
    );
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
  }

  isStringNullOrBlank(str: string) {
    return str === null || str.length === 0;
  }

  isValidEmail(email: string) {
    return this.emailReg.test(email);
  }

  createAccount(): boolean {
    if (
      this.isStringNullOrBlank(this.state.firstName) ||
      this.isStringNullOrBlank(this.state.lastName) ||
      this.isStringNullOrBlank(this.state.email) ||
      this.isStringNullOrBlank(this.state.password) ||
      this.isStringNullOrBlank(this.state.reTypePassword)
    ) {
      this.showAlert(
        configJSON.errorTitle,
        configJSON.errorAllFieldsAreMandatory
      );
      return false;
    }

    var phoneNumberError = this.validateCountryCodeAndPhoneNumber(
      this.state.countryCodeSelected,
      this.state.phone
    );

    if (phoneNumberError) {
      this.showAlert(configJSON.errorTitle, phoneNumberError);
      return false;
    }

    if (!this.isValidEmail(this.state.email)) {
      this.showAlert(configJSON.errorTitle, configJSON.errorEmailNotValid);
      return false;
    }

    if (!this.passwordReg.test(this.state.password)) {
      this.showAlert(configJSON.errorTitle, configJSON.errorPasswordNotValid);
      return false;
    }

    if (this.state.password !== this.state.reTypePassword) {
      this.showAlert(
        configJSON.errorTitle,
        configJSON.errorBothPasswordsNotSame
      );
      return false;
    }

    const header = {
      "Content-Type": configJSON.contentTypeApiAddDetail
    };

    const attrs = {
      first_name: this.state.firstName,
      last_name: this.state.lastName,
      email: this.state.email,
      password: this.state.password,
      full_phone_number: "+" + this.state.countryCodeSelected + this.state.phone
    };

    const data = {
      type: "email_account",
      attributes: attrs
    };

    const httpBody = {
      data: data,
      token: this.state.otpAuthToken
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.createAccountApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.accountsAPiEndPoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.apiMethodTypeAddDetail
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
    return true;
  }

  getCountryFlags = async () => {
    const headers = {
      "Content-Type": configJSON.signUpApiContentType
    };

    const getCountryFlagsMsg = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.getCountryFlagsApiCallId = getCountryFlagsMsg.messageId;

    getCountryFlagsMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.urlGetCountryFlags
    );

    getCountryFlagsMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );

    getCountryFlagsMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.termsConditionsApiMethodType
    );

    runEngine.sendMessage(getCountryFlagsMsg.id, getCountryFlagsMsg);
  };

  getValidations() {
    const headers = {
      "Content-Type": configJSON.validationApiContentType
    };

    const getValidationsMsg = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.validationApiCallId = getValidationsMsg.messageId;

    getValidationsMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.urlGetValidations
    );

    getValidationsMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    getValidationsMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.validationApiMethodType
    );
    runEngine.sendMessage(getValidationsMsg.id, getValidationsMsg);
  }

  isNonNullAndEmpty(value: String) {
    return (
      value !== undefined &&
      value !== null &&
      value !== "null" &&
      value.trim().length > 0
    );
  }

  validateCountryCodeAndPhoneNumber(countryCode: string, phoneNumber: string) {
    let error = null;

    if (this.isNonNullAndEmpty(phoneNumber)) {
      if (!this.isNonNullAndEmpty(String(countryCode))) {
        error = configJSON.errorCountryCodeNotSelected;
      }
    } else if (this.isNonNullAndEmpty(countryCode)) {
      if (!this.isNonNullAndEmpty(phoneNumber)) {
        error = "Phone " + configJSON.errorBlankField;
      }
    }

    return error;
  }

  imgEnableRePasswordFieldProps = {
    source: imgPasswordVisible
  };

  btnConfirmPasswordShowHideProps = {
    onPress: () => {
      this.setState({
        enableReTypePasswordField: !this.state.enableReTypePasswordField
      });
      this.txtInputConfirmPasswordProps.secureTextEntry = !this.state
        .enableReTypePasswordField;
      this.imgEnableRePasswordFieldProps.source = this
        .txtInputConfirmPasswordProps.secureTextEntry
        ? imgPasswordVisible
        : imgPasswordInVisible;
    }
  };

  imgEnablePasswordFieldProps = {
    source: imgPasswordVisible
  };

  btnPasswordShowHideProps = {
    onPress: () => {
      this.setState({ enablePasswordField: !this.state.enablePasswordField });
      this.txtInputPasswordProps.secureTextEntry = !this.state
        .enablePasswordField;
      this.imgEnablePasswordFieldProps.source = this.txtInputPasswordProps
        .secureTextEntry
        ? imgPasswordVisible
        : imgPasswordInVisible;
    }
  };

  btnSignUpProps = {
    onPress: () => this.createAccount()
  };

  btnLegalPrivacyPolicyProps = {
    onPress: () => this.goToPrivacyPolicy()
  };

  btnLegalTermsAndConditionProps = {
    onPress: () => this.goToTermsAndCondition()
  };

  txtInputEmailWebPrpos = {
    onChangeText: (text: string) => {
      this.setState({ email: text });
      //@ts-ignore
      this.txtInputEmailPrpos.value = text;
    }
  };

  txtInputEmailMobilePrpos = {
    ...this.txtInputEmailWebPrpos,
    keyboardType: "email-address"
  };

  txtInputEmailPrpos = this.isPlatformWeb()
    ? this.txtInputEmailWebPrpos
    : this.txtInputEmailMobilePrpos;

  txtPhoneNumberWebProps = {
    onChangeText: (text: string) => {
      this.setState({ phone: text });

      //@ts-ignore
      this.txtPhoneNumberProps.value = text;
    }
  };

  txtPhoneNumberMobileProps = {
    ...this.txtPhoneNumberWebProps,
    autoCompleteType: "tel",
    keyboardType: "phone-pad"
  };

  txtPhoneNumberProps = this.isPlatformWeb()
    ? this.txtPhoneNumberWebProps
    : this.txtPhoneNumberMobileProps;

  txtInputLastNamePrpos = {
    onChangeText: (text: string) => {
      this.setState({ lastName: text });

      //@ts-ignore
      this.txtInputLastNamePrpos.value = text;
    }
  };

  txtInputFirstNamePrpos = {
    onChangeText: (text: string) => {
      this.setState({ firstName: text });

      //@ts-ignore
      this.txtInputFirstNamePrpos.value = text;
    }
  };

  txtInputConfirmPasswordProps = {
    onChangeText: (text: string) => {
      this.setState({ reTypePassword: text });

      //@ts-ignore
      this.txtInputConfirmPasswordProps.value = text;
    },
    secureTextEntry: true
  };

  txtInputPasswordProps = {
    onChangeText: (text: string) => {
      this.setState({ password: text });

      //@ts-ignore
      this.txtInputPasswordProps.value = text;
    },
    secureTextEntry: true
  };

  // Customizable Area End
}
